var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz-result"},[_c('h1',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t("quiz.congrats")))]),_vm._v(" "+_vm._s(_vm.$t("quiz.finished"))+" "),_c('div',{staticClass:"coords"},[_vm._v("N 50° 03.582 E 19° 56.071")])])}
var staticRenderFns = []

export { render, staticRenderFns }